<script>
import ChangeDealership from './ChangeDealership.vue'
import StartOver from './StartOver'
import AcvMaxLogo from '~/icons/logos/AcvLogo.vue'

export default {
  components: {
    AcvMaxLogo,
    StartOver,
    ChangeDealership
  },
  props: {
    /** Whether user is navigating from showroom.max.auto */
    showroomNavigation: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    href: 'https://maxdigital.com/digital-retailing/max-bdc/?utm_source=Demo+Site&utm_medium=Banner&utm_campaign=MAX+BDC',
    year: new Date().getFullYear()
  }),
  computed: {
    isInternalPage: vm => vm.$route.path !== '/'
  }
}
</script>

<template>
  <footer
    class="footer--bdc primary font-size-xxs pa-6 d-flex align-center justify-center justify-md-space-between flex-wrap"
  >
    <a
      :href="href"
      class="d-flex flex-column flex-sm-row"
    >
      <p class="mr-1">
        Powered by
      </p>
      <AcvMaxLogo
        height="30"
      />
    </a>
    <span>
      &copy; {{ year }}
      <a :href="href">MAX Digital, LLC.</a>
      All Rights Reserved.
    </span>
    <div
      class="footer--bdc__actions d-flex align-center"
    >
      <ChangeDealership v-if="showroomNavigation" />
      <StartOver
        v-if="isInternalPage"
        color="secondary d-print-none"
        class="ma-0"
      />
    </div>
  </footer>
</template>

<style lang="scss">
.footer--bdc {
  color: #FFF;
  gap: 8px;

  a {
    color: #FFF;
    text-decoration: none;
  }

  .v-btn {
    text-transform: none;
  }

  &__logo p {
    display: inline;
    vertical-align: text-bottom;
  }

  &__actions {
    gap: 8px;
  }
}
</style>
